<template>
    <div class="container-fluid p-4">
        <!-- Main Group Settings Card -->
        <div class="card shadow-sm">
            <div class="card-body">
                <h2 class="mb-4">Neue Gruppe erstellen</h2>
                
                <form>
                    <!-- Group Name -->
                    <div class="form-group mb-4">
                        <label for="groupName" class="font-weight-bold">Gruppenname</label>
                        <input
                            v-model="t_groupName"
                            type="text"
                            class="form-control"
                            id="groupName"
                            placeholder="Gruppenname"
                            title="Eindeutige Bezeichnung der Gruppe"
                            @keydown.enter.prevent
                        >
                    </div>

                    <!-- File Upload Areas Side by Side -->
                    <div class="row mb-4">
                        <div class="col-md-6">
                            <label for="cashOrderFile" class="font-weight-bold">Kassenanordnungsvorlage</label>
                            <div
                                class="drop-area"
                                @drop.prevent="handleFileDropCashOrder"
                                @dragover.prevent
                                @click="$refs.cashOrderFile.click()"
                            >
                                <input
                                    type="file"
                                    id="cashOrderFile"
                                    ref="cashOrderFile"
                                    v-on:change="t_cashOrderFile = $refs.cashOrderFile.files[0]"
                                    style="display: none;"
                                />
                                <p v-if="t_cashOrderFile === null">Ziehe die ODT-Vorlage hier rein</p>
                                <p v-else>{{ t_cashOrderFile.name }}</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="countingProtocolFile" class="font-weight-bold">Zählprotokollvorlage</label>
                            <div
                                class="drop-area"
                                @drop.prevent="handleFileDropCountingProtocol"
                                @dragover.prevent
                                @click="$refs.countingProtocolFile.click()"
                            >
                                <input
                                    class="form-control-file"
                                    type="file" 
                                    id="countingProtocolFile" 
                                    ref="countingProtocolFile"
                                    v-on:change="t_countingProtocolFile = $refs.countingProtocolFile.files[0]"
                                    style="display: none;"
                                />
                                <p v-if="t_countingProtocolFile === null">Ziehe die ODS-Vorlage hier rein</p>
                                <p v-else>{{ t_countingProtocolFile.name }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Category Required Toggle Section -->
                    <div class="mb-4 pb-3">
                        <div class="d-flex align-items-center mb-2">
                            <input
                                v-model="transactionCategoryRequired"
                                type="checkbox"
                                class="mr-3"
                                id="transactionCategoryRequired"
                                style="width: 20px; height: 20px;"
                            >
                            <label class="mb-0 font-weight-bold" for="transactionCategoryRequired">
                                Kategorie bei Buchung erforderlich
                            </label>
                        </div>
                    </div>

                    <!-- Action Button -->
                    <div class="d-flex justify-content-end">
                        <button 
                            type="button"
                            v-on:click="perform('SAVE')" 
                            class="btn btn-success"
                        >
                            Gruppe speichern
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AddGroup',
    components: {},
    data() {
        return {
            error_msg: 'No Error',
            t_groupName: '',
            t_cashOrderFile: null,
            t_countingProtocolFile: null,
            transactionCategoryRequired: false,
        }
    },
    methods: {
        handleFileDropCashOrder(event) {
            this.t_cashOrderFile = event.dataTransfer.files[0];
            console.log(this.t_cashOrderFile);
            this.$refs.cashOrderFile.files = event.dataTransfer.files;
        },
        handleFileDropCountingProtocol(event) {
            this.t_countingProtocolFile = event.dataTransfer.files[0];
            this.$refs.countingProtocolFile.files = event.dataTransfer.files;
        },
        perform(actionType) {
            if (!confirm('Gruppe speichern?')) {
                return;
            }
            let msg = {type: "NONE"}
            const data = new FormData();
            data.append('groupName', this.t_groupName)
            data.append('transactionCategoryRequired', this.transactionCategoryRequired)
            if (this.t_cashOrderFile !== null) {
                data.append('cashOrderFile', this.t_cashOrderFile)
            }
            if (this.t_countingProtocolFile !== null) {
                data.append('countingProtocolFile', this.t_countingProtocolFile)
            }
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/groups',
                data: data,
                auth: credentials,
                method: 'post'
            }).catch(e => {
                console.log(e);
            }).then(resp => {
                msg = resp.data
                console.log("Message")
                console.log(msg)
                if (!(msg.type === "NONE")) {
                    console.log("Pushing error")
                    this.$store.commit('add_message', msg)
                } else if (!(msg.type === "ERROR")) {
                    this.t_groupName = ''
                }
                this.$store.dispatch('loadGroupData')
            });
            this.t_groupName = ''
            this.t_cashOrderFile = null
            this.t_countingProtocolFile = null
            this.transactionCategoryRequired = false
            this.$refs.cashOrderFile.value = null
            this.$refs.countingProtocolFile.value = null

        },
    },
    computed: {
        accountName() {
            return this.$store.state.current_acc;
        }
    }
};
</script>

<style scoped>
    .card {
        border-radius: 8px;
        border: 1px solid #e0e0e0;
    }

    .card-body {
        padding: 2rem;
    }

    .drop-area {
        border: 2px dashed #ccc;
        border-radius: 6px;
        padding: 60px 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #fafafa;
    }

    .drop-area:hover {
        border-color: #888;
        background-color: #f5f5f5;
    }

    .drop-area p {
        margin: 0;
        font-size: 14px;
        color: #666;
    }

    .shadow-sm {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
    }

    .font-weight-bold {
        font-weight: 600;
    }

    h2 {
        font-size: 1.75rem;
        font-weight: 600;
    }
</style>

